import "core-js/modules/es6.array.map";
import React from 'react';
import useSteps from '../hooks/use-steps';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Appear = function Appear(props) {
  var children = React.Children.toArray(props.children);
  var step = useSteps(children.length);
  var styled = children.map(function (child, i) {
    return React.cloneElement(child, {
      style: {
        visibility: i < step ? 'visible' : 'hidden'
      }
    });
  });
  return ___EmotionJSX(React.Fragment, null, styled);
};
export default Appear;